module.exports = __webpack_public_path__ + "static/media/photo-1.d81a4a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/cambridge-student-accommodation/photo-1.jpg
// module id = 153
// module chunks = 0